import React from 'react';
import Grid from '@mui/material/Grid';
import { connect } from 'react-redux';
import { Alert } from '@mui/material';
import EquipmentDataTable from '../elements/EquipmentDataTable';
import StagingFilterBuilder, { FilterDefinition } from '../elements/StagingFilterBuilder';
import EquipTypeLoader from '../../loaders/EquipTypeLoader';
import SliderFilterPopover, { SliderOptions } from '../elements/filter/SliderFilterPopover';
import TextFilterPopover from '../elements/filter/TextFilterPopover';
import EquipmentTypeFilterPopover from '../elements/filter/EquipmentTypeFilterPopover';
import {
  EquipmentTypeFilter,
  ContainsTextFilter,
  RangeFilter,
} from '../../../redux/constants/filters';
import PromotionResultDialog from '../elements/dialogs/PromotionResultDialog';

const filterDefs = [
  new FilterDefinition(
    EquipmentTypeFilterPopover,
    'equip_type',
    'Equip Type',
    {},
    (type) =>
      new EquipmentTypeFilter({
        key: 'equip_type',
        getter: (d) => d.data.equip_type,
        type,
      })
  ),
  new FilterDefinition(
    SliderFilterPopover,
    'equipConfidence',
    'Confidence',
    new SliderOptions([0, 100], [50, 100]),
    (v) =>
      new RangeFilter({
        key: 'equipConfidence',
        getter: (d) => d.confidences.equipment_type_id,
        minimum: v[0],
        maximum: v[1],
      })
  ),
  new FilterDefinition(
    TextFilterPopover,
    'equip_id',
    'Equip ID',
    {},
    (v) => new ContainsTextFilter({ key: 'equip_id', getter: (d) => d.equip_id, fragment: v })
  ),
  new FilterDefinition(
    TextFilterPopover,
    'device_id',
    'Device ID',
    {},
    (v) =>
      new ContainsTextFilter({ key: 'device_id', getter: (d) => d.data.device_id, fragment: v })
  ),
  new FilterDefinition(
    TextFilterPopover,
    'object_name',
    'Object Name',
    {},
    (v) =>
      new ContainsTextFilter({ key: 'object_name', getter: (d) => d.data.objectName, fragment: v })
  ),
  new FilterDefinition(
    TextFilterPopover,
    'model_name',
    'Model Name',
    {},
    (v) =>
      new ContainsTextFilter({ key: 'model_name', getter: (d) => d.data.modelName, fragment: v })
  ),
];

const EquipmentView = ({ buildingId, buildingError }) => {
  const [promotionResults, setPromotionResults] = React.useState(undefined);

  const onPromotionAction = (result) => {
    if (!result) return;
    setPromotionResults(result);
  };

  return (
    <>
      {buildingError.message ? (
        <Grid item xs={12}>
          <Alert severity="error">
            Errors detected with promotion:
            <p />
            {buildingError.message}
          </Alert>
        </Grid>
      ) : null}
      <Grid item xs={12}>
        <StagingFilterBuilder filterDefs={filterDefs} />
      </Grid>
      <Grid item xs={12}>
        <EquipTypeLoader />
        <EquipmentDataTable buildingId={buildingId} onPromotionResults={onPromotionAction} />
      </Grid>
      <PromotionResultDialog
        promotionResults={promotionResults}
        open={promotionResults !== undefined}
        onClose={() => setPromotionResults(undefined)}
      />
    </>
  );
};

const mapStateToProps = (state, { buildingId }) => {
  const {
    entities: {
      staging: {
        validation: { buildingErrors },
      },
    },
  } = state;

  return {
    buildingError: buildingErrors[buildingId ?? ''] ?? {},
  };
};

export default connect(mapStateToProps)(EquipmentView);
